import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import LinkButton from '../../../../../../components/LinkButton';
import {MESSAGE_TYPE} from '../../../../../../constants/message-types';
import ROUTE from '../../../../../../constants/route';

const InboxAdditionalDataCandidateNotifyReview = props => {
  const { type, id } = props;

  const url = useMemo(() => {
    if (type === MESSAGE_TYPE.TYPE_CANDIDATE_NOTIFY_REVIEW_OVERVIEW) {
      return ROUTE.ADD_REVIEW_COMPANY + '?firm=' + id;
    }

    if (type === MESSAGE_TYPE.TYPE_CANDIDATE_NOTIFY_REVIEW_INTERVIEW) {
      return ROUTE.ADD_REVIEW_INTERVIEW + '?firm=' + id;
    }

    if (type === MESSAGE_TYPE.TYPE_CANDIDATE_NOTIFY_REVIEW_EMPLOYEE) {
      return ROUTE.ADD_REVIEW_EMPLOYEE + '?position=' + id;
    }
  }, [type]);

  return (
    <div style={{ marginTop: '6px' }}>
      <LinkButton btnFontWeight={400} to={url} text="Write Review" />
    </div>
  );
};

InboxAdditionalDataCandidateNotifyReview.propTypes = {
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  type: PropTypes.oneOf([
    MESSAGE_TYPE.TYPE_CANDIDATE_NOTIFY_REVIEW_OVERVIEW,
    MESSAGE_TYPE.TYPE_CANDIDATE_NOTIFY_REVIEW_INTERVIEW,
    MESSAGE_TYPE.TYPE_CANDIDATE_NOTIFY_REVIEW_EMPLOYEE,
  ]),
};

export default InboxAdditionalDataCandidateNotifyReview;
